export enum INVESTIGATION_STATUS {
	BEGINNING = 'beginning',
	INPROGRESS = 'inProgress',
	FINALQUESTION = 'finalQuestion',
	UPLOADFILE = 'addSupportingDocuments',
	SUBMITTING = 'completingInvestigation',
	COMPLETED = 'completed',
	EXPIRED = 'expired',
	CUTOFF = 'cutoff',
}

export type INVESTIGATION_TYPES = {
	status: INVESTIGATION_STATUS;
};

export enum DRAWER_SCREENS {
	RFISUMMARY = 'rfiSummary',
	CLIENTINFO = 'clientInfo',
}

export enum INVESTIGATION_ANSWERED_BY {
	CLIENT = 'client',
	BRANCH = 'branch',
	CLIENTANDBRANCH = 'clientAndBranch',
}
